  // Footer newsletter

KlaviyoSubscribe.attachToForms("#footer_nl_signup", {
    hide_form_on_success: true,
    custom_success_message: true,
    success: function ($form) {
      window.dataLayer = window.dataLayer || [];
      var email = document.getElementById('k_id_email').value; // Get the email value
      dataLayer.push({
        event: 'custom_events',
        event_name: 'newsletter_sign_up',
        form_type: 'Newsletter',
        form_offer: '33% off your first order',
        email: email // Use the email from the input
      });
      $("#footer_nl_signup .form-wrapper, #footer_nl_signup .optin, #footer_nl_signup > p").hide();
    },
    extra_properties: {
      $source: "Footer Newsletter",
    },
  });

  // Newsletter modal

KlaviyoSubscribe.attachToForms("#footer_nl_signup_b", {
    hide_form_on_success: true,
    custom_success_message: true,
    success: function ($form) {
      window.dataLayer = window.dataLayer || [];
      var email = document.getElementById('k_id_email_B').value; // Get the email value
      dataLayer.push({
        event: 'custom_events',
        event_name: 'newsletter_sign_up',
        form_type: 'Newsletter',
        form_offer: '33% off your first order',
        email: email // Use the email from the input
      });
      console.log(
        {
          event: 'custom_events',
          event_name: 'newsletter_sign_up',
          form_type: 'Newsletter',
          form_offer: '33% off your first order',
          email: email // Use the email from the input
        }
      )
      $(".newsletter-modal .state-one").hide();
      $(".newsletter-modal .state-two").show();
      var email = $("#k_id_email_B").val();
      $("#k_id_email_C").val(email);
    },
    extra_properties: {
        $source: "Newsletter modal",
    },
});

  // Step 2

KlaviyoSubscribe.attachToForms("#footer_nl_signup_c", {
    hide_form_on_success: true,
    custom_success_message: true,
    success: function ($form) {
      $(".j-klavyio-hide-on-success").hide();
      $(".j-klavyio-success-msg").show();
      setTimeout(function () {
        $(".j-close-newsletter").click();
      }, 3000);
    },
    extra_properties: {
      $source: "Newsletter modal - personal",
    },
});

  // Strava Challenge Form

KlaviyoSubscribe.attachToForms("#strava-form-signup", {
    hide_form_on_success: true,
    custom_success_message: true,
    success: function ($form) {
      $("#strava-form-signup .fields").hide();
      if ($("#strava-form-signup").siblings(".results-panel").first().length) {
        $("#strava-form-signup").hide();
        $(".results-panel").first().show();
        $("html,body").animate(
          {
            scrollTop: $(".overview-title-box").first().offset().top - 250,
          },
          1000
        );
      }
    },
    error: function ($form) {
      console.log("error:", $form);
      $("#strava-form-signup .klaviyo_messages .error_message").text($form[0]);
    },
    extra_properties: {
      $source: "Strava Page Form 2021",
    },
});

  // Back in stock — notify me when live (one form per product card / PDP)

$(".back-in-stock-form").each(function () {
    var $bis = $(this);
    var $ctx = $bis.closest(".product-item, .product-template");
    // Move the form into the CTA area so it visually replaces the button. The
    // form is rendered outside the product <form> (nested forms are dropped by
    // the HTML parser); moving it in via the DOM keeps it a working form.
    var $cardRow = $ctx.find(".product-card-nov24__cta-row").first();
    if ($cardRow.length) {
        // Product card: drop into the CTA row.
        $bis.appendTo($cardRow);
    } else {
        // PDP: place the form as a full-width row item, before the shipping-note
        // block (falling back to the end of the grid-x row).
        var $shippingCell = $ctx.find(".shipping-note").first().closest(".cell");
        if ($shippingCell.length) {
            $bis.insertBefore($shippingCell);
        } else {
            var $grid = $ctx.find(".add-to-cart-btn").first().closest(".grid-x");
            if ($grid.length) $bis.appendTo($grid);
        }
    }

    // Initial state. Multi-variant cards also get toggled by the `filter` event
    // in ecom.js on load, but single-variant products have no variant selectors
    // (so `filter` never fires) — evaluate the selected option's stock here.
    var $selected = $ctx.find(".j-id option:selected");
    $bis.find("[data-klaviyo-list-id-input]").val($selected.data("klaviyo-list-id") || "");
    if ($selected.attr("data-sold-out") === "true") {
        var $cta = $ctx.find(".product-card-nov24__cta-row-inner");
        if (!$cta.length) $cta = $ctx.find(".add-to-cart-btn").closest(".cell").add($ctx.find(".qty-selector").closest(".cell"));
        $cta.hide();
        $bis.show();
    }

    KlaviyoSubscribe.attachToForms("#" + $bis.attr("id"), {
        hide_form_on_success: true,
        custom_success_message: true,
        success: function ($form) {
          $form.find(".form-wrapper").hide();
        },
        extra_properties: {
          $source: "Product card back in stock form",
        },
    });
});